import { useEffect, useRef } from 'react'

// setInterval that pauses while the browser tab is hidden. Each poll hits an
// edge function and writes ~5 Supabase log rows, so background tabs left open
// all day were most of our log ingestion. On return, refetches immediately if
// a poll was missed, then resumes the interval.
export default function useVisiblePolling(callback, intervalMs, enabled) {
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => {
    if (!enabled) return
    let id = null
    let hiddenAt = null

    const start = () => {
      if (id === null) id = setInterval(() => callbackRef.current(), intervalMs)
    }
    const stop = () => {
      if (id !== null) { clearInterval(id); id = null }
    }
    const onVisibilityChange = () => {
      if (document.hidden) {
        stop()
        hiddenAt = Date.now()
      } else {
        if (hiddenAt !== null && Date.now() - hiddenAt >= intervalMs) callbackRef.current()
        hiddenAt = null
        start()
      }
    }

    if (document.hidden) hiddenAt = Date.now()
    else start()
    document.addEventListener('visibilitychange', onVisibilityChange)
    return () => {
      stop()
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [enabled, intervalMs])
}
